import { Injectable } from '@angular/core';
import { AbstractHttpService } from './abstract-http-service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { OfferSetListResponse } from '../model/offer-set-list-response.model';
import { OfferSetBulkActionRequest, OfferSetBulkActionResponse } from '../model/offer-set-bulk-action.model';
import {OfferSetCreateRequest, OfferSetCreateResponse} from '../model/offer-set-create.model';
import {CreateAdFromStockResponse} from '../model/create-ad-from-stock.model';

@Injectable({
  providedIn: 'root'
})
export class OfferSetListService extends AbstractHttpService {
  defaultOptions = {
    headers: this.contentTypeJsonHeaders,
    withCredentials: true
  };

  constructor(private httpClient: HttpClient) {
    super();
  }

  /**
   * Gets paginated Offer Sets list for an account
   */
  public getOfferSetList(
    accountId: number,
    preset: string,
    status: string,
    condition: string,
    visibility: string,
    search: string,
    page: number,
    pageSize: number
  ): Observable<OfferSetListResponse> {
    let params = new HttpParams()
      .set('preset', preset)
      .set('status', status)
      .set('condition', condition)
      .set('visibility', visibility)
      .set('page', page.toString())
      .set('pageSize', pageSize.toString());

    if (search) {
      params = params.set('search', search);
    }

    return this.httpClient
      .get<OfferSetListResponse>(
        `//${environment.autoDomain}:${environment.autoPort}/api/offer-sets/list/${accountId}`,
        { ...this.defaultOptions, params }
      )
      .pipe(catchError(this.handleError));
  }

  /**
   * Executes a bulk action on selected Offer Sets
   */
  public executeBulkAction(request: OfferSetBulkActionRequest): Observable<OfferSetBulkActionResponse> {
    return this.httpClient
      .post<OfferSetBulkActionResponse>(
        `//${environment.autoDomain}:${environment.autoPort}/api/offer-sets/list/${request.accountId}/bulk-actions`,
        request,
        this.defaultOptions
      )
      .pipe(catchError(this.handleError));
  }

  /**
   * Creates a new Offer Set (manual create) via the shared create endpoint
   */
  public createOfferSet(request: OfferSetCreateRequest): Observable<OfferSetCreateResponse> {
    return this.httpClient
      .post<OfferSetCreateResponse>(
        `//${environment.autoDomain}:${environment.autoPort}/api/offer-set`,
        request,
        this.defaultOptions
      )
      .pipe(catchError(this.handleError));
  }

  /**
   * Creates an ad through the existing Launch Control stock endpoint
   */
  public createAdFromStock(
    accountId: number,
    stockNumber: string,
    expectedCondition: string
  ): Observable<CreateAdFromStockResponse>
  {
    const encodedStockNumber = encodeURIComponent(stockNumber);
    const encodedCondition = encodeURIComponent(expectedCondition);

    return this.httpClient
      .post<CreateAdFromStockResponse>(
        `/includes/ajax/mpop-api/admin-ads/create-ad-from-stock/${accountId}/${encodedStockNumber}/${encodedCondition}`,
        {},
        this.defaultOptions
      )
      .pipe(catchError(this.handleError));
  }
}
